<template>
  <section class="page-section">
        <!-- filter -->
        <div class="filter-region no-margin-top">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="日期：" prop="timeType" style="margin-right: 5px">
                <el-select v-model="filterForm.timeType" placeholder="请选择" @change="() => filterForm.time = ''">
                  <el-option label="全部" value="0"></el-option>
                  <el-option label="自然月" value="1"></el-option>
                  <el-option label="自然年" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" prop="time" v-if="filterForm.timeType == '1'">
                <el-date-picker v-model="filterForm.time" type="month" placeholder="选择月" class="w120"></el-date-picker>
              </el-form-item>
              <el-form-item label="" prop="time" v-if="filterForm.timeType == '2'">
                <el-date-picker v-model="filterForm.time" type="year" placeholder="选择年" class="w120"></el-date-picker>
              </el-form-item>
              <el-form-item label="状态：" prop="status">
                <el-select v-model="filterForm.status" placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="待处理" value="0"></el-option>
                  <el-option label="已核销" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>

        <!-- table -->
        <div class="table-region" v-loading="tableLoading">
          <el-table size="small" :data="tableData" ref="multipleTable">
            <el-table-column label="ID">
              <template slot-scope="scope">
                <p>{{ scope.row.id }}</p>
              </template>
            </el-table-column>
            <el-table-column label="昵称">
              <template slot-scope="scope">
                <p>{{ scope.row.userName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="手机号">
              <template slot-scope="scope">
                <p>{{ scope.row.mobile }}</p>
              </template>
            </el-table-column>
            <el-table-column label="兑换券类型">
              <template slot-scope="scope">
                <p v-if="scope.row.couponType == 3">现金券</p>
                <p v-if="scope.row.couponType == 4">商品券</p>
              </template>
            </el-table-column>
            <el-table-column label="兑换内容">
              <template slot-scope="scope">
                <p>{{ scope.row.exchangeContent }}</p>
              </template>
            </el-table-column>
            <el-table-column label="兑换申请时间" width="95">
              <template slot-scope="scope">
                <p>{{ COMMON.formatDate('2', '-', scope.row.createDate) }}</p>
              </template>
            </el-table-column>
            <el-table-column label="收款账户" width="200">
              <template slot-scope="scope">
                <p>开户行：{{ scope.row.bank }}<br>卡号：{{ scope.row.card }}</p>
              </template>
            </el-table-column>
            <el-table-column label="兑换凭证">
              <template slot-scope="scope">
                <div class="thumb-list">
                  <div class="thumb-wrap" v-for="(item, itemIndex) in scope.row.pics" :key="itemIndex"
                    @click="handlePicturesPreview(item)">
                    <img :src="item">
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <p v-if="scope.row.status == 0">待处理</p>
                <p v-if="scope.row.status == 1">已核销</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <!-- 已完成 -->
                <el-popover placement="top" width="165" v-model="scope.row.visible" popper-class="confirm-popover"
                  v-if="scope.row.status == 0">
                  <p>确定已完成该兑换申请？</p>
                  <div>
                    <el-button size="small" type="default" plain
                      @click="handleChangeCancle(scope.row, scope.$index)">取消</el-button>
                    <el-button size="small" type="primary" @click="handleChangeStatus(scope.row, scope.$index)"
                      :loading="scope.row.changeLoading">确定</el-button>
                  </div>

                  <el-button size="small" type="text" slot="reference">已完成</el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate"></div>

          <div class="pagination-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>


<el-dialog class="preview-modal" :visible.sync="imgVisible" append-to-body>
  <img width="100%" :src="dialogImageUrl" alt="photo">
</el-dialog>
      </section>
</template>

<script>
import { COMMON, financialCouponExchangeList, financialCouponExchangeComplete } from '@/common/api'

export default {
  name: 'goodsManageList',
  data() {
    return {
      COMMON,

      filterForm: { //筛选表单值
        timeType: '0',
        time: '',
        status: ''
      },

      tableLoading: true,
      tableData: [], //表格数据
      page: {
        current: 1,
        size: 20,
        total: 0
      },

      dialogImageUrl: '', // 原图片弹窗路径
      imgVisible: false, // 原图片弹窗是否显示
      tableHeight: 400
    }
  },
  methods: {
    // 获取当前月份起始和结束的毫秒数
    getMonthRange(time) {
      const now = new Date(time);
      const year = now.getFullYear();
      const month = now.getMonth();

      // 当月第一天0点0分0秒
      const start = new Date(year, month, 1).getTime();

      // 下个月第一天0点0分0秒减1毫秒
      const end = new Date(year, month + 1, 1).getTime() - 1;

      return { start, end };
    },
    // 获取当前年份起始和结束的毫秒数
    getYearRange(time) {
      const now = new Date(time);
      const year = now.getFullYear();

      // 当年第一天0点0分0秒
      const start = new Date(year, 0, 1).getTime();

      // 下一年第一天0点0分0秒减1毫秒
      const end = new Date(year + 1, 0, 1).getTime() - 1;

      return { start, end };
    },
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList: function () {
      let startTime = 0
      let endTime = 0
      if (this.filterForm.timeType && this.filterForm.time) {
        let timeRange
        if (this.filterForm.timeType == 1) {
          timeRange = this.getMonthRange(this.filterForm.time)
        } else if (this.filterForm.timeType == 2) {
          timeRange = this.getYearRange(this.filterForm.time)
        }
        startTime = timeRange.start
        endTime = timeRange.end
      }

      this.tableLoading = true;

      let params = {
        startTime: startTime,
        endTime: endTime,
        status: this.filterForm.status === '' ? null : parseFloat(this.filterForm.status),
        pageNo: this.page.current,
        pageSize: this.page.size
      }

      financialCouponExchangeList(params).then(res => {
        this.tableLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data.records || [];

          this.tableData = dataArray;
          this.page.total = data.total;
          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.page.current = 1;

      this.getList();
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [handleChangeCancle description] 单个商品上下线 - 取消
     * @param  {[type]} row   [description]
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    handleChangeCancle: function (row, index) {
      row.visible = false;
      row.changeLoading = false;

      this.$set(this.tableData, index, row);
    },
    /**
     * [handleChangeStatus description] 已完成
     * @param  {[type]} row   [description]
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    handleChangeStatus: function (row, index) {
      row.changeLoading = true;
      this.$set(this.tableData, index, row);

      let params = {
        exchangeId: row.id
      }

      financialCouponExchangeComplete(params).then(res => {
        row.changeLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.$message({ message: '操作成功', type: 'success' });
          this.getList();
        } else {
          this.$message.error(msg);
        }

        this.$set(this.tableData, index, row);
      }).catch(error => {
        row.changeLoading = false;
        this.$set(this.tableData, index, row);
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handlePictureCardPreview description] 图片预览
     * @param  {[type]} file [description]
     * @return {[type]}      [description]
     */
    handlePicturesPreview: function (url) {
      this.dialogImageUrl = url;
      this.imgVisible = true;
    },
    /**
     * [calcTableHeight description] 动态计算表格高度
     * @return {[type]} [description]
     */
    // calcTableHeight() {
    //   const tableRegion = document.querySelector('.table-region')
    //   const tableFooter = document.querySelector('.table-footer')
    //   if (tableRegion) {
    //     const regionHeight = tableRegion.clientHeight
    //     const footerHeight = tableFooter ? tableFooter.offsetHeight : 0
    //     // 减去上下间距
    //     this.tableHeight = regionHeight - footerHeight - 20
    //     this.$nextTick(() => {
    //       this.$refs.multipleTable && this.$refs.multipleTable.doLayout()
    //     })
    //   }
    // }
  },
  mounted() {
    this.getList();
    // this.$nextTick(() => {
    //   this.calcTableHeight()
    // })
    // window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.calcTableHeight)
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

// .page-container {
//   height: 100%;
// }

// .page-main {
//   flex: 1;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
// }

// .page-section {
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   overflow: hidden;
// }

.filter-region {
  // flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;

  .filter-form {
    flex: 1;
  }

  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        &+.el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.no-margin-top {
  margin-top: 0;
}

.table-region {
  // flex: 1; // 占用剩余高度
  // display: flex;
  // flex-direction: column;
  // overflow: hidden;
  margin-bottom: 50px;

  ::v-deep .el-table {
    // flex: 1;

    &::before {
      height: 0;
    }

  }

  // 修复固定列头部背景色不一致问题
  ::v-deep .el-table__fixed-right-patch {
    background-color: #f6f7f9; // $colorTitleBg 的值，或者直接写变量如果可用
    border-bottom: none;
  }

  ::v-deep .el-table__fixed-right {
    thead th {
      background-color: #f6f7f9;
      border-bottom: none;
    }

    &::before {
      height: 0;
    }
  }

  // .table-footer {
  //   flex-shrink: 0; // 分页区域不压缩，保持固定高度
  // }
}

.thumb-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;

  .thumb-wrap {
    position: relative;
    width: 48px;
    height: 48px;
    margin-right: 5px;
    background-color: $colorPageBg;

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }
}
</style>
